import React from 'react';
import {Link} from 'react-router-dom';

class OnboardingStepsComplete extends React.Component {
  render() {
    return (
      <div>
        <h3>Welcome to the Rangers</h3>

        <p>
          Now that you've joined the Ranger Team, click the training link below to learn how to complete
          your first charge.
        </p>

        <ul>
          <li>Finding Skips</li>
          <li>Charging Skips</li>
          <li>Deploying Skips</li>
        </ul>

        <p>
          We'll be sending you an email or SMS shortly with instructions on getting your Skip charging packs.
        </p>


        <Link
          className='btn btn-lg btn-primary mt-2'
          to="/training"
        >
          Start Training
        </Link>
      </div>
    )
  }
}

OnboardingStepsComplete.propTypes = {}

export {OnboardingStepsComplete};


// WEBPACK FOOTER //
// ./src/street-team/onboarding/OnboardingStepsComplete.js